import { render, staticRenderFns } from "./ManageLegalRoleModal.vue?vue&type=template&id=268500fa&scoped=true&"
import script from "./ManageLegalRoleModal.vue?vue&type=script&lang=js&"
export * from "./ManageLegalRoleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268500fa",
  null
  
)

export default component.exports